<template>
  <booking-section id="room-results" :title="$t('booking.sectionTitles.roomResults')"  @section-clicked="sectionClicked" contentClass="" :collapsed="moduleCollapsed">
    <div class="row" v-if="loaded && !errorState">
        <div class="column small-12" v-if="result && result.global.is_short_term">
          <div class="booking-element booking-error" v-html="result.global.short_term_notice"></div>
        </div>

        <div class="column small-12" v-if="errorResults.length > 0 && fullResults.length == 0">
          <div class="booking-element booking-error">
            {{ errorResults[0][0].message }}
          </div>
        </div>

        <div class="column small-12 medium-12 large-4 room" v-else v-for="(curResult) in _.sortBy(fullResults, 'price')" :class="{'is-holiday-package': curResult.package_name}">
          <div class="booking-element room-result--top spacer-mini">
            <div class="room__title">
              <span v-for="(r,i) in roomResultName(curResult)">
                <span v-if="i > 0">+</span>{{ r }}
                <br />
              </span>
            </div>
            <div class="room__img" :style="bgImage(curResult.picture_url)">

              <div class="special-indicator" v-if="curResult.package_name">
                <div class="special-indicator--label">{{ curResult.package_name }}</div>
              </div>

            </div>
            <div class="room__description text-xsmall">
              <div class="room__description--label" v-for="desc in curResult.description">{{ desc }}</div>
            </div>

            <div v-if="!curResult.loading">
              <div class="room__price spacer-small" :class="{'special-offer': curResult.is_special_offer }">
                <span v-if="curResult.is_special_offer">SPECIAL OFFER: </span>ab {{ formatNumber(curResult.price_pp) }} p. Erw.
                <div class="error small" v-if="curResult.calculation_data[0].api_meta && curResult.calculation_data[0].api_meta.non_refundable">nicht stornierbar</div>
              </div>

              <div class="text-xsmall text-right metainfo">
                ab {{ curResult.price_display }} gesamt für alle Reisende
                <br/>
                {{curResult.type_name }}
              </div>
              <div class="metainfo">{{curResult.result_name}}</div>
              <div class="metainfo text-xsmall" v-if="curResult.flight && curResult.flight.offset_notice">
                Bitte beachten Sie, das sich aufgrund der Flugzeit der Aufenthalt vor Ort um einen Tag verkürzt
              </div>
            </div>
            <loader v-else title="Preis wird ermittelt" details="Einen Moment bitte"></loader>
          </div>

          <div class="booking-element room-result--bottom" v-if="!curResult.loading">
            <div class="row room__prices">
              <div class="column small-12">

                <div class="room__prices__info text-xsmall" v-for="detail in curResult.result_names">
                  <span>{{detail.count}}x</span>
                  <span v-html="splittedDetails(detail.name)"></span>
                </div>

                <div v-if="result && !result.global.is_short_term">
                  <a class="cta cta--small" v-if="curResult.flight" @click="getFlightResults(curResult)">
                    <img src="/images/icons_svg/airplane-icon.svg" class="svg-icon"></img>
                    Auswählen
                  </a>
                  <a class="cta cta--small" v-else @click="sendBookingProceed(curResult)">
                    Auswählen
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column small-12 text-center" v-if="(resultData.length - fullResults.length) > 0">
          <template v-if="!updatingResults">
            <a class="cta cta--inline cta--dark"  @click="loadBookingResultDetails" v-if="resultData.length != (errorResults.length + fullResults.length)">
              Mehr Ergebnisse laden 
              <br />
              noch {{resultData.length - fullResults.length}} verbleibend
            </a>
            <div class="metainfo text-center"></div>
          </template>
          <loader v-else title="Zimmer werden geladen"></loader>
        </div>


        <loader @click="loadBookingResultDetails" v-if="loadedResultsCount == 0" title="Ergebnisse werden geladen" :details="`Noch ${resultData.length - fullResults.length} verbleibend`"></loader>
    </div>
    <div v-else-if="loaded && errorState">
      <error-message :errors="errors" @step-back="stepBackTo('datepicker')"></error-message>
    </div>
    <div v-else-if="result && result.global.flight && result.global.status == 'NOK'" class="column small-12">
      <div class="booking-element booking-error">
        <h3><b>Für den aktuellen Zeitraum stehen leider keine Flüge zur Verfügung</b></h3>
        <p>Aufgrund der aktuell geltenden internationalen Einschränkungen im Flugverkehr sind für Ihre Anfrage leider keine Flugverbindungen vorhanden.</p>
        <p>
          Bitte wählen Sie einen anderen Flughafen oder ein anderes Reisedatum.<br/>
          Gerne können Sie sich auch direkt an unseren Kundenservice wenden – dieser wird für Sie ein passendes individuelles Angebot erstellen.
        </p>
        <p class="text-center"><a class="cta cta--inline" target="blank" :href="`/kontaktanfrage?topic=${result.global.request_topic}`">Kundenservice kontaktieren</a></p>
      </div>
    </div>
    <loader v-else title="Aktuelle Verfügbarkeiten werden geprüft" details="Einen Augenblick bitte"></loader>

  </booking-section>


</template>

<script>

import axios from 'axios'
import resultLoader from '../booking/mixins/resultLoader'
import bookingDefaults from '../booking/mixins/bookingDefaults'

export default {
  props: ['productId', 'isVpMode'],
  mixins: [resultLoader, bookingDefaults],
  components: {
    loader: () => import('../shared/loader.vue')
  },
  data: function () {
    return {
      currentStep: 'roomResults',
      getServicesUrl: `${process.env.BASE_URL}/api/booking/${this.productId}/get_services`,
      currentLoadingProgress: 2,
      duration: 30,
      fullResults: [],
      errorResults: [],
      loadedResultsCount: 0,
      roomResultsPerCycle: 6,
      updatingResults: false,
    }
  },
  watch: {
    loaded: {
      handler(){
        if (this.loaded == true){
          this.currentLoadingProgress = 100
          clearInterval(window.roomLoader)
          $("#lxd > .filter").hide()
        }
      }
    },
    resultData: {
      handler(val){
        this.fullResults = []
        this.errorResults = []

        this.loadBookingResultDetails()
      }
    }
  },
  methods: {

    loadBookingResultDetails(){

      var resultsToLoad = this.resultData.slice(this.loadedResultsCount, this.loadedResultsCount+(this.roomResultsPerCycle))
      this.updatingResults = true

      console.log(this.resultData.length, this.loadedResultsCount, this.loadedResultsCount+(this.roomResultsPerCycle))

      resultsToLoad.forEach((r,i) => {
        if (this.loadedResultsCount < this.resultData.length){
          const url = this.apiUrl((this.result.global.flight ? 'calculate_with_flight' : 'calculate_hotel_only'))
          return new Promise((resolve, reject) => {
            axios.get(url, { params: {
              calculationData: this.result.global.calculation_data,
              room_id: r.id, api_meta: r.api_meta, // r.api_meta contains additional data provided by API for further booking
              flight_proposal_id: this.result.global.flight_proposal_id
            } })
            .then(response => {
              if (response.data.global.status == 'OK') {
                response.data.results[0].description = r.description
                this.fullResults.push(response.data.results[0])
              }else{
                this.errorResults.push(response.data.global.errors)
              }
              if (i == resultsToLoad.length-1){
                this.updatingResults = false
              }
              this.loadedResultsCount = this.loadedResultsCount+1
              console.log(this.loadedResultsCount)
            })
            .catch(error => {

            })
          })


        }

      })
    },


    // BOOKING ACTIONS
    getFlightResults(data){
      this.$emit('next-started', 'flightResults')
      this.gTrack('proceedWithFlight')
      axios.get(`${process.env.BASE_URL}/api/booking/${this.productId}/get_flight_results`, { params: { calculation_data: JSON.stringify(data.calculation_data), price: data.price } })
      .then(response => {
        
        if (response.data.global.status == "NOK"){
          this.showGlobalErrorMessage(response.data.global.errors)
          this.$emit('failed')
        }else{
          this.$emit('next-loaded', 'flight', response.data)
        }  
        
        
      })
      .catch(e => {  console.log(e) })
    },
    sendBookingProceed(data){
      if (this.isVpMode || true == true){
        this.$emit('next-started', 'services')
      }else{
        this.$emit('next-started', 'leadForm')
      }

     this.gTrack('proceedHotelOnly')
     axios.post(this.getServicesUrl, { calculation_data: JSON.stringify(data.calculation_data), price: data.price }  )
      .then(response => {
        if (response.data.global.status == "NOK"){
          this.showGlobalErrorMessage(response.data.global.errors)
          this.$emit('failed')
        }else{
          this.$emit('next-loaded', 'noflight', response.data)
        }
       
      })

    },
    // VIEW HELPERS
    bgImage(url){
      return `background-image: url('${url}')`
    },
    splittedDetails(data){
      return data.split(",").join("<br />")
    },
    roomResultName(result){
      var names = []
      result.result_names.forEach(rName => {
        names.push(rName.name.split(",")[0])
      })
      return names
    }
  }
}
</script>

<style lang="scss" scoped>

</style>